import React from "react";

// One install-method card with numbered steps.
export const InstallCard = ({ id, icon: Icon, title, desc, steps, highlight, children, testid }) => (
  <article id={id} data-testid={testid}
    className={`relative rounded-3xl bg-white p-6 sm:p-8 scroll-mt-24 transition-shadow duration-300 ${highlight ? "ring-2 ring-sky-400 shadow-[0_24px_60px_-28px_rgba(14,165,233,0.6)]" : "ring-1 ring-slate-200"}`}>
    {highlight && <span className="absolute -top-3 left-6 px-2.5 py-0.5 rounded-full bg-sky-500 text-[11px] font-semibold text-white" data-testid={`${testid}-your-device`}>Your device</span>}
    <div className="flex items-center gap-3">
      <span className="w-11 h-11 rounded-2xl bg-slate-900 text-white flex items-center justify-center"><Icon size={20} /></span>
      <div>
        <h2 className="font-display text-xl font-semibold text-slate-900">{title}</h2>
        <p className="text-sm text-slate-500">{desc}</p>
      </div>
    </div>
    <ol className="mt-6 space-y-3.5">
      {steps.map((s, i) => (
        <li key={i} className="flex gap-3.5 text-sm text-slate-600 leading-relaxed">
          <span className="shrink-0 w-6 h-6 rounded-full bg-sky-50 ring-1 ring-sky-200 text-sky-700 text-xs font-semibold flex items-center justify-center">{i + 1}</span>
          <span className="pt-0.5">{s}</span>
        </li>
      ))}
    </ol>
    {children && <div className="mt-7 flex flex-wrap items-center gap-3">{children}</div>}
  </article>
);

export default InstallCard;
